import { parseISO, getHours } from "date-fns";
import { getDoorOpenedAtNightFirstLine, getNoTimeOutsideFirstLine } from "./";

export const handleIndependence = (data, filterName) => {
  const noTimeOutside = data?.map((day) => {
    const timeOutside = day?.activityData
      ?.filter((activity) => activity.userState === "outside")
      .reduce((total, current) => total + current.durationMinutes, 0);
    return {
      date: day?.date,
      value: timeOutside,
      firstLineText: getNoTimeOutsideFirstLine(timeOutside),
      isHighlighted: timeOutside === 0,
      noData: getNoTimeOutsideFirstLine(timeOutside) === "No data",
    };
  });
  const doorOpenedAtNight = data?.map((day) => {
    const numberOfFrontDoorEventsAtNight =
      day?.frontDoorEvents?.openedAt?.reduce((count, timestamp) => {
        const date = parseISO(timestamp);
        return getHours(date) < 6 ? count + 1 : count;
      }, 0);
    const numberOfSecondaryDoorEventsAtNight =
      day?.secondaryDoorEvents?.openedAt?.reduce((count, timestamp) => {
        const date = parseISO(timestamp);
        return getHours(date) < 6 ? count + 1 : count;
      }, 0) || 0;
    return {
      date: day?.date,
      value: day?.value,
      firstLineText: getDoorOpenedAtNightFirstLine(
        numberOfFrontDoorEventsAtNight + numberOfSecondaryDoorEventsAtNight
      ),
      isHighlighted:
        numberOfFrontDoorEventsAtNight + numberOfSecondaryDoorEventsAtNight > 0,
      noData:
        getDoorOpenedAtNightFirstLine(
          numberOfFrontDoorEventsAtNight + numberOfSecondaryDoorEventsAtNight
        ) === "No data",
    };
  });

  if (filterName === "doorOpenedAtNight") {
    return doorOpenedAtNight;
  }
  return noTimeOutside;
};
